<template>
  <div class="animated fadeIn">
    <Tables
      ref="tableGrid"
      :columns="['MOTIVO', 'SITUAÇÃO', $lang.Common.DataTable.Actions]"
      :showNew="true"
      :showSearch="false"
      :showReload="true"
      :showTipFooter="false"
      v-on:New="onNew"
      v-on:Load="onLoad"
      v-on:Reload="onLoad"
    >
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inactive ? 0 : 1"
          :value="obj.nome ? obj.nome.toUpperCase() : ''"
        />
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inactive ? 0 : 1"
          :value="
            obj.situacao
              ? obj.situacao.toUpperCase() === 'FINALIZADO'
                ? 'FINALIZAÇÃO'
                : obj.situacao.toUpperCase() === 'PERDIDO'
                ? 'PERDA'
                : ''
              : ''
          "
        />
        <TableColumn
          :IsInactiveButtons="true"
          v-on:ToggleInactive="toggleInactive(obj)"
          :status="obj.inactive ? 0 : 1"
        />
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button
          type="button"
          class="btn btn-third btn-sm"
          v-on:click="$emit('New')"
          v-b-tooltip.hover
          :title="'Clique para cadastrar'"
        >
          <i class="fas fa-user-plus"></i>
          <span class="d-md-down-none">&nbsp; Novo</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import ReasonRepository from '@/shared/http/repositories/configurations/reason.js'

export default {
  name: 'ReasonLossList',
  mixins: [ActionsForm],
  methods: {
    onLoad () {
      loading.push()
      ReasonRepository.GetAllPaging(
        this.$refs.tableGrid.pagingLimit,
        this.$refs.tableGrid.pagingIndex
      )
        .then(response => {
          this.onResultGrid(response)
        })
        .catch(err => {
          this.onException(err)
        })
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    toggleInactive (obj) {
      loading.push()
      ReasonRepository.ChangeStatus(obj.id, obj)
        .then(response => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/board/reason/components/list/reasonlist.vue